/**
 * Menus options
 * Used for the general SiteMenus.
 *
 * Breaks each menu down by type:
 * 		standard: Standard list of links
 * 		iconic:   Standard menu plus icons next to each item
 * 		indexed:  Alphabetized list of links with letter next to each group of
 * 				  items that fall under that letter.
 */

export const fonts = {
	defaultSection: 'collections',
	menuLevel: 1,
	name: 'fonts',
	source: 'local',
	type: 'standard',
	sections: [
		{
			default: true,
			icon: null,
			link: '/fonts/styles',
			opensSubMenu: true,
			secondaryMenu: 'collections',
			section: null,
			slug: 'styles',
			text: 'Browse by Style',
			withSectionDivider: false
		}, {
			default: false,
			icon: null,
			link: '/fonts/find-by-name',
			opensSubMenu: true,
			secondaryMenu: 'findByName',
			section: null,
			slug: 'find-by-name',
			text: 'Find by Name',
			withSectionDivider: false
		}, {
			default: false,
			icon: null,
			link: '/fonts/type-capsules',
			opensSubMenu: true,
			secondaryMenu: 'typeCapsules',
			section: null,
			slug: 'type-capsules',
			text: 'Type Capsules',
			withSectionDivider: false
		}, {
			default: false,
			icon: null,
			link: '/fonts/latest-releases',
			opensSubMenu: false,
			secondaryMenu: null,
			section: null,
			slug: 'latest-releases',
			text: 'What’s New',
			withSectionDivider: true
		}, {
			default: false,
			icon: null,
			link: '/webfonts',
			opensSubMenu: false,
			secondaryMenu: null,
			section: null,
			slug: 'webfonts',
			text: 'Web Fonts',
			withSectionDivider: false
		}
	]
};

export const about = {
	dontBreakOnHeader: 1,
	hasColumnsOnDesktop: false,
	layout: 'standard',
	menuLevel: 1,
	name: 'about',
	source: 'local',
	type: 'standard',
	sections: [
		{
			icon: null,
			link: '/about-us',
			section: null,
			slug: 'about',
			text: 'Meet H&Co',
			sections: [
				{
					column: 1,
					name: 'The Fine Print',
					slug: 'fine-print',
					sections: [
						{
							icon: null,
							link: '/policies/eula',
							slug: 'eula',
							text: 'EULA'
						}, {
							icon: null,
							link: '/policies/web-fonts-terms',
							slug: 'web-fonts-terms',
							text: 'Web Fonts'
						}, {
							icon: null,
							link: '/policies/cloud-terms',
							slug: 'cloud-typography',
							text: 'Cloud.typography'
						}, {
							icon: null,
							link: '/policies/app-terms',
							slug: 'app-typography',
							text: 'App.typography'
						}, {
							icon: null,
							link: '/policies/privacy',
							slug: 'privacy',
							text: 'Privacy'
						}, {
							icon: null,
							link: '/policies/terms',
							slug: 'site-terms',
							text: 'Site Terms'
						}
					]
				}, {
					column: 2,
					name: 'Channels',
					slug: 'channels',

					sections: [
					 	{
							icon: null,
							link: '/subscribe',
							slug: 'subscribe',
							text: 'Email'
						}, {
							external: true,
							icon: null,
							link: 'https://www.instagram.com/hoeflerco/',
							slug: 'instagram',
							text: 'Instagram'
						}, {
							external: true,
							icon: null,
							link: 'https://twitter.com/HoeflerCo',
							slug: 'twitter',
							text: 'Twitter'
						}, {
							external: true,
							icon: null,
							link: 'https://www.facebook.com/HoeflerCo/',
							slug: 'facebook',
							text: 'Facebook'
						}, {
							external: true,
							icon: null,
							link: 'http://dribbble.com/hoeflerco',
							slug: 'dribbble',
							text: 'Dribbble'
						}, {
							external: true,
							icon: null,
							link: 'https://www.youtube.com/channel/UCJ7qMNLhxiz8EOUqpM6jkxw',
							slug: 'youtube',
							text: 'YouTube'
						}, {
							external: true,
							icon: null,
							link: 'https://www.linkedin.com/company/hoeflerco',
							slug: 'linked',
							text: 'LinkedIn'
						}
					]
				}
			]
		}, {
			icon: null,
			link: '/contact',
			section: null,
			slug: 'contact',
			text: 'Contact'
		}
	]
};

export const account = {
	dontBreakOnHeader: 1,
	hasColumnsOnDesktop: false,
	layout: 'standard',
	menuLevel: 1,
	name: 'account',
	source: 'local',
	type: 'standard',
	sections: [
		{
			icon: 'credit-card',
			link: '/account/details',
			section: null,
			slug: 'account-details',
			text: 'Account Details',
			sections: [
				{
					column: 1,
					name: 'Subscriptions',
					slug: 'subscriptions',
					sections: [
						{
							icon: null,
							link: '/dashboard',
							slug: 'cloud-typography-dashboard',
							text: 'Cloud Dashboard'
						}, {
							icon: null,
							link: '/account/subscriptions',
							slug: 'manage-subscriptions',
							text: 'Manage Subscriptions'
						}, {
							icon: null,
							link: '/account/renew/cloud',
							slug: 'manage-expired-cloud-subscription',
							text: 'Manage Subscriptions'
						}, {
							icon: null,
							link: '/usage-reports',
							slug: 'usage-reports',
							text: 'Usage Reports'
						}
					]
				}, {
					column: 2,
					name: 'Purchases',
					slug: 'purchases',
					sections: [
						{
							icon: null,
							link: '/account/font-library',
							slug: 'font-library',
							text: 'Font Library'
						}, {
							icon: null,
							link: '/account/order-history',
							slug: 'order-history',
							text: 'Order History'
						}
					]
				}, {
					column: 2,
					name: 'Resources',
					slug: 'resources',
					sections: [
						{
							icon: null,
							link: '/favorites',
							slug: 'favorites',
							text: 'Your Favorites'
						}
					]
				}
			]
		}
	],
	cta: {
		icon: 'sign-out',
		link: '/account/signout',
		text: 'Sign out'
	}
};

export const collections = {
	additional: 'collections',
	menuLevel: 2,
	name: 'collections',
	nested: true,
	sections: null,
	source: 'api',
	title: 'Browse by Style',
	type: 'iconic'
};


export const typeCapsules = {
	menuLevel: 2,
	name: 'typeCapsules',
	nested: false,
	source: 'local',
	title: 'Type Capsules',
	type: 'capsules'
};

export const findByName = {
	menuLevel: 2,
	name: 'findByName',
	nested: false,
	source: 'local',
	title: 'Find by Name',
	type: 'indexed',
	sections: [
		{
			section: null,
			icon: null,
			link: '/fonts/acropolis',
			slug: 'acropolis',
			secondaryMenu: null,
			text: 'Acropolis'
		}, {
			section: null,
			icon: null,
			link: '/fonts/archer',
			slug: 'archer',
			secondaryMenu: null,
			text: 'Archer'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Bayside Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/champion-gothic',
			slug: 'gothic',
			secondaryMenu: null,
			text: 'Champion Gothic'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-display',
			slug: 'display',
			secondaryMenu: null,
			text: 'Chronicle Display'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-display',
			slug: 'display',
			secondaryMenu: null,
			text: 'Chronicle Display Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-display',
			slug: 'display',
			secondaryMenu: null,
			text: 'Chronicle Display Compressed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-text',
			slug: 'text',
			secondaryMenu: null,
			text: 'Chronicle Deck'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-text',
			slug: 'text',
			secondaryMenu: null,
			text: 'Chronicle Deck Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-display',
			slug: 'display',
			secondaryMenu: null,
			text: 'Chronicle Hairline'
		}, {
			section: null,
			icon: null,
			link: '/fonts/chronicle-text',
			slug: 'text',
			secondaryMenu: null,
			text: 'Chronicle Text'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Claimcheck Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/cyclone',
			slug: 'cyclone',
			secondaryMenu: null,
			text: 'Cyclone'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Delancey Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Depot Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Deuce Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/didot',
			slug: 'didot',
			secondaryMenu: null,
			text: 'Didot'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Dividend Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/historical-allsorts',
			slug: 'allsorts',
			secondaryMenu: null,
			text: 'English Textura'
		}, {
			section: null,
			icon: null,
			link: '/fonts/historical-allsorts',
			slug: 'allsorts',
			secondaryMenu: null,
			text: 'The Fell Types'
		}, {
			section: null,
			icon: null,
			link: '/fonts/forza',
			slug: 'forza',
			secondaryMenu: null,
			text: 'Forza'
		}, {
			section: null,
			icon: null,
			link: '/fonts/giant',
			slug: 'giant',
			secondaryMenu: null,
			text: 'Giant'
		}, {
			section: null,
			icon: null,
			link: '/fonts/gotham',
			slug: 'gotham',
			secondaryMenu: null,
			text: 'Gotham'
		}, {
			section: null,
			icon: null,
			link: '/fonts/gotham',
			slug: 'gotham',
			secondaryMenu: null,
			text: 'Gotham Narrow'
		}, {
			section: null,
			icon: null,
			link: '/fonts/gotham',
			slug: 'gotham',
			secondaryMenu: null,
			text: 'Gotham Extra Narrow'
		}, {
			section: null,
			icon: null,
			link: '/fonts/gotham',
			slug: 'gotham',
			secondaryMenu: null,
			text: 'Gotham Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/gotham-rounded',
			slug: 'rounded',
			secondaryMenu: null,
			text: 'Gotham Rounded'
		}, {
			section: null,
			icon: null,
			link: '/fonts/historical-allsorts',
			slug: 'allsorts',
			secondaryMenu: null,
			text: 'Great Primer Uncials'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Greenback Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/historical-allsorts',
			slug: 'allsorts',
			secondaryMenu: null,
			text: 'Historical Allsorts'
		}, {
			section: null,
			icon: null,
			link: '/fonts/hoefler-text',
			slug: 'text',
			secondaryMenu: null,
			text: 'Hoefler Text'
		}, {
			section: null,
			icon: null,
			link: '/fonts/hoefler-text',
			slug: 'text',
			secondaryMenu: null,
			text: 'Hoefler Titling'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ideal-sans',
			slug: 'sans',
			secondaryMenu: null,
			text: 'Ideal Sans'
		}, {
			section: null,
			icon: null,
			link: '/fonts/idlewild',
			slug: 'idlewild',
			secondaryMenu: null,
			text: 'Idlewild'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Indicia Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/inkwell',
			slug: 'inkwell',
			secondaryMenu: null,
			text: 'Inkwell'
		}, {
			section: null,
			icon: null,
			link: '/fonts/knockout',
			slug: 'knockout',
			secondaryMenu: null,
			text: 'Knockout'
		}, {
			section: null,
			icon: null,
			link: '/fonts/knox',
			slug: 'knox',
			secondaryMenu: null,
			text: 'Knox'
		}, {
			section: null,
			icon: null,
			link: '/fonts/landmark',
			slug: 'landmark',
			secondaryMenu: null,
			text: 'Landmark'
		}, {
			section: null,
			icon: null,
			link: '/fonts/leviathan',
			slug: 'leviathan',
			secondaryMenu: null,
			text: 'Leviathan'
		}, {
			section: null,
			icon: null,
			link: '/fonts/mercury-display',
			slug: 'display',
			secondaryMenu: null,
			text: 'Mercury Display'
		}, {
			section: null,
			icon: null,
			link: '/fonts/mercury-text',
			slug: 'text',
			secondaryMenu: null,
			text: 'Mercury Text'
		}, {
			section: null,
			icon: null,
			link: '/fonts/nitro-turbo',
			slug: 'turbo',
			secondaryMenu: null,
			text: 'Nitro'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/obsidian',
			slug: 'obsidian',
			secondaryMenu: null,
			text: 'Obsidian'
		}, {
			section: null,
			icon: null,
			link: '/fonts/operator',
			slug: 'operator',
			secondaryMenu: null,
			text: 'Operator'
		}, {
			section: null,
			icon: null,
			link: '/fonts/Operator',
			slug: 'operator',
			secondaryMenu: null,
			text: 'Operator Mono'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Premium Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Prospekt Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/the-proteus-project',
			slug: 'project',
			secondaryMenu: null,
			text: 'The Proteus Project'
		}, {
			section: null,
			icon: null,
			link: '/fonts/quarto',
			slug: 'quarto',
			secondaryMenu: null,
			text: 'Quarto'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Redbird Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/requiem',
			slug: 'requiem',
			secondaryMenu: null,
			text: 'Requiem'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Revenue Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ringside',
			slug: 'ringside',
			secondaryMenu: null,
			text: 'Ringside Extra Wide'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ringside',
			slug: 'ringside',
			secondaryMenu: null,
			text: 'Ringside Wide'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ringside',
			slug: 'ringside',
			secondaryMenu: null,
			text: 'Ringside Regular'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ringside',
			slug: 'ringside',
			secondaryMenu: null,
			text: 'Rinside Narrow'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ringside',
			slug: 'ringside',
			secondaryMenu: null,
			text: 'Ringside Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ringside',
			slug: 'ringside',
			secondaryMenu: null,
			text: 'Ringside Compressed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/saracen',
			slug: 'saracen',
			secondaryMenu: null,
			text: 'Saracen'
		}, {
			section: null,
			icon: null,
			link: '/fonts/sentinel',
			slug: 'sentinel',
			secondaryMenu: null,
			text: 'Sentinel'
		}, {
			section: null,
			icon: null,
			link: '/fonts/shades',
			slug: 'shades',
			secondaryMenu: null,
			text: 'Shades'
		}, {
			section: null,
			icon: null,
			link: '/fonts/historical-allsorts',
			slug: 'allsorts',
			secondaryMenu: null,
			text: 'St. Augustin Civilité'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Strasse Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/surveyor',
			slug: 'surveyor',
			secondaryMenu: null,
			text: 'Surveyor'
		}, {
			section: null,
			icon: null,
			link: '/fonts/topaz',
			slug: 'topaz',
			secondaryMenu: null,
			text: 'Topaz'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Trafalgar Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/tungsten',
			slug: 'tungsten',
			secondaryMenu: null,
			text: 'Tungsten'
		}, {
			section: null,
			icon: null,
			link: '/fonts/tungsten',
			slug: 'tungsten',
			secondaryMenu: null,
			text: 'Tungsten Narrow'
		}, {
			section: null,
			icon: null,
			link: '/fonts/tungsten',
			slug: 'tungsten',
			secondaryMenu: null,
			text: 'Tungsten Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/tungsten',
			slug: 'tungsten',
			secondaryMenu: null,
			text: 'Tungsten Compressed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/tungsten-rounded',
			slug: 'rounded',
			secondaryMenu: null,
			text: 'Tungsten Rounded'
		}, {
			section: null,
			icon: null,
			link: '/fonts/nitro-turbo',
			slug: 'turbo',
			secondaryMenu: null,
			text: 'Turbo'
		}, {
			section: null,
			icon: null,
			link: '/fonts/numbers',
			slug: 'numbers',
			secondaryMenu: null,
			text: 'Valuta Numbers'
		}, {
			section: null,
			icon: null,
			link: '/fonts/verlag',
			slug: 'verlag',
			secondaryMenu: null,
			text: 'Verlag'
		}, {
			section: null,
			icon: null,
			link: '/fonts/verlag',
			slug: 'verlag',
			secondaryMenu: null,
			text: 'Verlag Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/verlag',
			slug: 'verlag',
			secondaryMenu: null,
			text: 'Verlag Compressed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/vitesse',
			slug: 'vitesse',
			secondaryMenu: null,
			text: 'Vitesse'
		}, {
			section: null,
			icon: null,
			link: '/fonts/whitney',
			slug: 'whitney',
			secondaryMenu: null,
			text: 'Whitney'
		}, {
			section: null,
			icon: null,
			link: '/fonts/whitney-narrow',
			slug: 'narrow',
			secondaryMenu: null,
			text: 'Whitney Narrow'
		}, {
			section: null,
			icon: null,
			link: '/fonts/whitney-condensed',
			slug: 'condensed',
			secondaryMenu: null,
			text: 'Whitney Condensed'
		}, {
			section: null,
			icon: null,
			link: '/fonts/ziggurat',
			slug: 'ziggurat',
			secondaryMenu: null,
			text: 'Ziggurat'
		}
	]
};

export const help = {
	layout: 'standard',
	menuLevel: 1,
	name: 'help',
	sections: [
		{
			sections: [
				{
					column: 2,
					name: 'Help',
					slug: 'help',
					sections: [
						{
							icon: null,
							link: '/contact',
							slug: 'contact',
							text: 'Contact'
						}, {
							icon: null,
							link: '/faq',
							slug: 'faq',
							text: 'FAQ'
						}, {
							icon: null,
							link: '/user-guide',
							slug: 'user-guide',
							text: 'Cloud.typography User Guide'
						}, {
							external: true,
							icon: null,
							link: 'http://status.typography.com',
							slug: 'cloud-status',
							text: 'Cloud.typography Status'
						}
					]
				}
			]
		}
	],
	source: 'local',
	type: 'standard'
};

export default {
	about,
	account,
	collections,
	findByName,
	typeCapsules,
	fonts,
	help
};
